import React from 'react';
import { Check, CheckCheck } from 'lucide-react';

const MessageStatus = ({ status = 'sent' }) => {
    // Status: 'sent', 'delivered', 'read'
    const getStatusIcon = () => {
        switch (status) {
            case 'read':
                // Light blue/cyan that contrasts well with teal background
                return <CheckCheck className="w-4.5 h-4.5 text-cyan-200" strokeWidth={2.5} />;
            case 'delivered':
                return <CheckCheck className="w-4.5 h-4.5 text-white/90" strokeWidth={2.5} />;
            case 'sent':
            default:
                return <Check className="w-4.5 h-4.5 text-white/80" strokeWidth={2.5} />;
        }
    };

    return (
        <span data-testid={`message-status-${status}`} className="inline-flex items-center ml-1.5">
            {getStatusIcon()}
        </span>
    );
};

export default MessageStatus;

